import { BrowserMultiFormatReader } from '@zxing/library';
const codeReader = new BrowserMultiFormatReader();

function start_scanner(user) {
  //let selectedDeviceId;
  if ($('#barcode-scanner').length > 0) {
    codeReader.listVideoInputDevices()
      .then(videoInputDevices => {
        //selectedDeviceId = videoInputDevices[0].deviceId

        codeReader.decodeFromVideoDevice(undefined, 'barcode-scanner', (result, err) => {
          if (result) {
            console.log(result.text)
            let barcodeData = result.text
            $('#item_code').val(result.text);
            $('#code').val(result.text);

            // call the user's respective modal
            display_modal(user, barcodeData);

          }
          if (err && err.name != 'NotFoundException') {
            console.error(err)
          }
        })
        // console.log(`Started continous decode from camera with id ${selectedDeviceId}`)
      })
      .catch(error => {
        console.error(error);
      })
  }
}

function stop_scanner() {
  codeReader.reset()
}

function incrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('#' + fieldName).val(), 10);

  if (!isNaN(currentVal)) {
    parent.find('#' + fieldName).val(currentVal + 1);
  } else {
    parent.find('#' + fieldName).val(0);
  }
}

function decrementValue(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('#' + fieldName).val(), 10);

  if (!isNaN(currentVal) && currentVal > 1) {
    parent.find('#' + fieldName).val(currentVal - 1);
  } else {
    var default_value = (fieldName == 'item_qty') ? 1 : 0
    parent.find('#' + fieldName).val(default_value);
  }
}

function institutionValue() {
  return $('#item_institution_id, #institution_id').val() == "" ? false : true
}

function get_collection_count(id) {
    // request to get the collections details
    $.ajax({
      url: '/collections/' + id,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function(data) {
        if (data) {
          $('#dry-count').text(data.dry_count);
          $('#cold-count').text(data.cold_count);
        } else {
          $('#dry-count').text(0);
          $('#cold-count').text(0);
        }
      },
      error: function(xhr, exception, status) {
        $('#dry-count').text(0);
        $('#cold-count').text(0);
      }
    });
}

function display_modal(user, data) {
  if (user === 'driver') {
    $('#scanResult').modal('show');
  } else if (user === 'warehouse') {
    $('#warehouseScanResult').modal('show');
  }
  $('#scanCode').text(data);
}

$(document).on('turbolinks:load', function() {
  let id = localStorage.getItem('institution_id')

  if (id) {
    // set the value of institution dropdown
    $('#item_institution_id, #institution_id').val(id)
    // url to view the list of scanned items
    $('#list_link').prop('href', '/driver?institution_id='+id);
    // url to view the collected items for institution
    $('#summary_link').prop('href', '/collections/'+id+'/summary');
    // url to view the collected items for institution
    $('#warehouse_summary_link').prop('href', '/warehouse/'+id+'/summary');
    // get the collection details
    get_collection_count(id);
  }

  // Open the camera preview
  $('#scanButton').on('click', function(e) {
    e.preventDefault();
    let user = $(this).data('for');
    if (institutionValue()) {
      if ($(this).val() === 'true') {
        $(this).val('false');
        stop_scanner();
        $(this).text('SCAN');
      } else {
        $(this).val('true');
        start_scanner(user);
        $(this).text('STOP');
      }
    } else {
      $('#item_institution_id, #institution_id').addClass('is-invalid');
    }
  });

  // click listener for quantity plus and minus button
  $('.input-group').on('click', '.button-plus', function(e) {
    incrementValue(e);
  });
  $('.input-group').on('click', '.button-minus', function(e) {
    decrementValue(e);
  });

  // close modal after clicking continue button
  $('.modal-footer .continue-btn').click(function() {
    $('#scanResult').modal('hide');
  });

  // close modal after clicking continue button
  $('.modal-footer .ok-btn').on('click', function() {
    $('#warehouseScanResult').modal('hide');
  });

  $('#scanResult').on('hidden.bs.modal', function() {
    $('.quantity-field').val('1');
    let id = localStorage.getItem('institution_id');
    get_collection_count(id);
  });

  // listen to institution selection
  $('#item_institution_id, #institution_id').on('change', function(e) {
    e.preventDefault();
    $('#item_institution_id').removeClass('is-invalid');
    $('#institution_id').removeClass('is-invalid');
    let id = $(this).val();
    if (id !== "") {
      // save insitution_id in local storage
      localStorage.setItem('institution_id', id);

      // url to view the list of scanned items
      $('#list_link').prop('href', '/driver?institution_id='+id);

      // url to view the collected items for institution
      $('#summary_link').prop('href', '/collections/'+id+'/summary');

      // url to view the collected items for institution
      $('#warehouse_summary_link').prop('href', '/warehouse/'+id+'/summary');

      // request to get the collections details
      get_collection_count(id);

    } else {
      // remove insitution_id in local storage
      localStorage.removeItem('institution_id');
      $('#dry-count').text(0);
      $('#cold-count').text(0);
    }
  });

  // listen to manual barcode input
  $('#manualField').on('keyup blur', function() {
    $('#manualButton').prop('disabled', this.value.length > 0 ? false : true);
  });

  // clicking the manual entry for barcode
  $('#manualButton').on('click', function(e) {
    e.preventDefault();

    if (institutionValue()) {
      $('#manualButton').prop('disabled', true);

      let manualbarcode = $('#manualField').val();
      $('#manualField').val('');

      // set the value in hidden field
      $('#item_code').val(manualbarcode);
      $('#code').val(manualbarcode);

      // get current user
      let user = $('#scanButton').data('for');

      // call the user's respective modal
      display_modal(user, manualbarcode);
    } else {
      $('#item_institution_id, #institution_id').addClass('is-invalid');
    }
  });

  $('#alex-delivers-logo').on('click', function(e) {
    $('#logoutModal').modal('show');
  });

  // auto-dismiss the alert
  $(".alert-dismissible").fadeTo(2000, 500).slideUp(500, function(){
    $(".alert-dismissible").alert('close');
  });

});
